<template>
  <hk-dropdown v-if="!hideDropDown">
    <div class="dropdown-custom"
         type="primary"
         slot="activator">
      <users style="width:15px;font-size: 14px;" class="user-icon"></users>
      <span style="padding:0 10px" dir="ltr"> {{ adultsAndChildren }}</span>
    </div>
    <div slot="dropdown" slot-scope="{ events: { closeModal } }">
      <div class="dropdown-header">
        <el-button size="mini" plain @click.stop="closeModal" @click="guestsChanged()"  >{{ $t('lbl_ok') }}</el-button>
      </div>
      <div class="guests-dropdown" v-for="(item, index) in rooms" :key="index">
        <div class="room-number"> {{ $t("lbl_room") }} {{ (roomIndex || index) + 1 }}</div>
        <div class="rooms-chosen-dropdown" style="font-size: 14px; font-weight: 400">
          <div>
            <span>{{ $t("lbl_adults") }}</span>
            <stepper
              stepper
              @increase="item.persons.adults++;"
              @decrease="item.persons.adults--;"
              :min="1"
              :max="maxGuests(item, item.persons.adults)"
              :model.sync="item.persons.adults"></stepper>
          </div>
          <div>
            <span>{{ $t("lbl_children") }}</span>
            <stepper
              @increase="pushChildrenAges(item, (roomIndex || index) || 0); item.persons.children++;"
              @decrease="popChildrenAges(item, (roomIndex || index) || 0); item.persons.children--;"
              :min="0"
              :max="maxGuests(item, item.persons.children)"
              :model.sync="item.persons.children"></stepper>
          </div>
          <div class="children-age" v-if="item.persons.children > 0 && enable_children_ages">
            <div class="font-small m-b-5">{{ $t("lbl_add_age_of_children") }}</div>
            <div class="flexed gap-10" style="width: 198px; flex-wrap: wrap">
              <div v-for="(child, i) in item.persons.children_ages" :key="'age_of_children_' + i" >
                <!-- <el-input style="width:42px" size="mini" v-model="item.persons.children_ages[i]"
                          ></el-input> -->
                <el-select style="width:60px;" size="mini" filterable v-model="item.persons.children_ages[i]" placeholder="Age">
                  <el-option v-for="age in childrenAges" :key="age" :label="age" :value="age"></el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </hk-dropdown>
  <div v-else>
    <div class="guests-dropdown" v-for="(item, index) in rooms" :key="index">
      <div class="room-number"> Room {{ +(roomIndex || index) + 1 }}</div>
      <div class="rooms-chosen-dropdown" style="font-size: 14px; font-weight: 400">
        <div>
          <span>{{ $t("lbl_adults") }}</span>
          <stepper
            stepper
            @increase="item.persons.adults++;guestsChanged()"
            @decrease="item.persons.adults--;guestsChanged()"
            :min="1"
            :max="maxGuests(item, item.persons.adults)"
            :model.sync="item.persons.adults"></stepper>
        </div>
        <div>
          <span>{{ $t("lbl_children") }}</span>
          <stepper
            @increase="pushChildrenAges(item, (roomIndex || index) || 0); item.persons.children++;guestsChanged()"
            @decrease="popChildrenAges(item, (roomIndex || index) || 0); item.persons.children--;guestsChanged()"
            :min="0"
            :max="maxGuests(item, item.persons.children)"
            :model.sync="item.persons.children"></stepper>
        </div>
        <div class="children-age" v-if="item.persons.children > 0 && enable_children_ages">
          <div class="font-small m-b-5">Add Age of Children</div>
          <div class="flexed gap-10" style="width: 198px; flex-wrap: wrap">
            <div v-for="(child, i) in item.persons.children_ages" :key="'age_of_children_' + i" >
              <!-- <el-input style="width:42px" size="mini" v-model="item.persons.children_ages[i]"
                        ></el-input> -->
                <el-select style="width:60px" size="mini" filterable v-model="item.persons.children_ages[i]" placeholder="Age" @mouseleave.stop @change="guestsChanged()">
                  <el-option v-for="age in childrenAges" :key="age" :label="age" :value="age"></el-option>
                </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HkDropdown from "../../../../components/common/hk-dropdown";
import stepper from "../../../../components/stepper";
import {UsersIcon} from "vue-feather-icons";
import deepClone from 'clone'
import { mapState } from 'vuex';
import moment from "moment";

export default {
  name: "GuestsFilter",
  props: ['searchData', 'hideDropDown', 'roomIndex'],
  components: {HkDropdown, stepper, users: UsersIcon},
  data() {
    return {
      roomCount: null,
      guestCount: null,
      childrenCount: null,
      childrenAges: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17],
      rooms: null,
    }
  },
  computed: {
    ...mapState({
      propertyDetails: state => state.property?.details,
      search_data: (state) => state.search_data,
      children_ages: state => state.children_ages
    }),
    adultsAndChildren() {
      if(!this.rooms) return
      if (!isNaN(this.roomIndex)) {
        let allRoomsAdults = this.search_data.rooms[this.roomIndex].persons.adults
        let allRoomsChildren = this.search_data.rooms[this.roomIndex].persons.children
        return `${allRoomsAdults} ${this.$t('lbl_adults')}, ${allRoomsChildren} ${this.$t('lbl_children')}`
      } else {
        let allRoomsAdults = this.rooms.reduce((b, a) => b + a.persons.adults, 0)
        let allRoomsChildren = this.rooms.reduce((b, a) => b + a.persons.children, 0)
        return `${allRoomsAdults} ${this.$t('lbl_adults')}, ${allRoomsChildren} ${this.$t('lbl_children')}`
      }
    },
    maxNumberOfGuests(){
      return this.propertyDetails?.website_config?.max_guests_allowed || 6
    },
    enable_children_ages(){
      return this.propertyDetails?.application_configuration?.enable_children_ages
    }
  },
  methods: {
    guestsChanged() {
      // let payload = {
      //   guests: item,
      //   guestIndex: index,
      //   // children_ages: this.children_ages
      // }
      // this.$emit('emitRoomsFromGuest', this.rooms)
      this.$emit('guestsChanged', this.rooms);
    },
    maxGuests(item, val){
      return  (item.persons.adults + item.persons.children) >= this.maxNumberOfGuests ? val : this.maxNumberOfGuests
    },
    pushChildrenAges(item, index) {
      if(this.enable_children_ages && this?.rooms[index]?.persons?.children_ages) {
        this?.rooms[index]?.persons?.children_ages.push(0)
      }
    },
    popChildrenAges(item, index) {
      if(this.enable_children_ages && this?.rooms[index]?.persons?.children_ages) {
        this?.rooms[index]?.persons?.children_ages.pop()
      }
    },
    childrenAgesFromURL() {
      if (this.$route.query.children && this.$route.query.children > 0 && this.enable_children_ages) {
        const childrenCount = Number(this.$route.query.children);
        const roomCount = Number(this.$route.query.room_count) || 1;

        this.searchData.rooms.forEach(room => {
          room.persons.children_ages = [];
        });

        let remainingChildren = childrenCount;
        for (let i = 0; i < roomCount; i++) {
          const childrenForRoom = Math.min(Math.ceil(remainingChildren / (roomCount - i)), remainingChildren);
          for (let j = 0; j < childrenForRoom; j++) {
            this.searchData.rooms[i].persons?.children_ages?.push(0);
          }
          remainingChildren -= childrenForRoom;
        }
      }
    }


  },
  mounted() {
    this.$nextTick(() => {
      this.childrenAgesFromURL();

      const roomIndex = this.roomIndex ? this.roomIndex : 0
      if (!isNaN(this.roomIndex)) {
        this.rooms = [deepClone(this.searchData.rooms[roomIndex])];
      } else {
        this.rooms = deepClone(this.searchData.rooms)
      }
    });
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/sass/config/variables";
@import "../../../../assets/sass/config/mixins";

.dropdown-custom {
  -webkit-appearance: none;
  background-color: #FFF;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 53.5px;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  // margin-left: 10px;

  .user-icon {
    color: $hk-primary-color;
  }
}

:deep(.list-scroll) {
  max-height: 470px !important;
  overflow: auto !important;
}

.guests-dropdown {
  padding: 20px 20px 0 20px;
  width: 250px;

  .room-number {
    display: flex;
    margin-bottom: 5px;
    color: #b1b1b1;
    font-size: 12px;
  }

  .add-another-room {
    font-size: 11px;
    margin-top: 3px;
    cursor: pointer;
  }

  .rooms-chosen-dropdown {
    margin-bottom: 10px;
    border-bottom: 1px solid #dadada;

    > div {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }

    .room-number {
      display: flex;
      margin-bottom: 5px;
      color: #b1b1b1;
    }

    .remove {
      color: #409eff;
      cursor: pointer;
    }
  }
}

.children-age {
  display: flex;
  flex-direction: column;
  align-items: flex-start !important;
  border: none;
  background: white;
  padding: 0px 10px;

  :deep(.el-input__inner) {
    padding: 0px 10px !important;
  }
}
.children-age:last-of-type{
  padding-bottom: 10px;
}

@include media('<=tablet') {
  .dropdown-custom {
    // line-height: 40px;
  }
  .guests-dropdown {
    padding: 10px 10px 0 10px;
    width: 100%;
  }
}

.dropdown-header{
  background-color: whitesmoke;
  padding: 6px;
  display: flex;
  justify-content: flex-end;
}

:deep(button.el-button--mini){
  min-width: auto;
}
</style>
